import * as React from 'react';
import styled from 'styled-components';
import { Icon } from '@packages/ui';

import { Arrow, ArrowProps } from '../Arrow/Arrow';

const ArrowLeftStyled = styled(Arrow)<{ elevation: number | number[] }>`
  border-radius: 0 28px 28px 0;
`;

export const ArrowLeft: React.FC<ArrowProps> = ({ onClick, className }) => {
  return (
    <ArrowLeftStyled onClick={onClick as any} elevation={2} className={className}>
      <Icon size={16} name="chevronLeft" />
    </ArrowLeftStyled>
  );
};
